import React, { useEffect, useState } from 'react';
import { fetchDeviationSettings, updateDeviationSettings } from '../../services/api';
import { ui } from '../../styles/shared';
import CollapsiblePanel from './CollapsiblePanel';

interface Props {
    onError: (message: string) => void;
}

// Inställning för påminnelse när en avvikelserapport inte skickats in i tid.
const DeviationSettings: React.FC<Props> = ({ onError }) => {
    const [reminderHours, setReminderHours] = useState<number>(48);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const s = await fetchDeviationSettings();
                setReminderHours(s.reminder_hours);
            } catch { /* inte kritiskt */ }
        })();
    }, []);

    const save = async () => {
        setSaving(true);
        try {
            await updateDeviationSettings({ reminder_hours: reminderHours });
        } catch (e: any) {
            onError(e.message || 'Kunde inte spara inställningar');
        } finally {
            setSaving(false);
        }
    };

    return (
        <CollapsiblePanel title="📋 Avvikelserapportering">
            <div>
                <label style={ui.label}>Påminnelse efter (timmar)</label>
                <input
                    type="number" min={1}
                    style={{ ...ui.input, width: '100px' }}
                    value={reminderHours}
                    onChange={e => setReminderHours(Number(e.target.value))}
                />
                <div style={ui.hint}>Skicka påminnelse om avvikelsen ej rapporterats inom X timmar</div>
            </div>
            <button onClick={save} disabled={saving} style={{ ...ui.btnPrimary, opacity: saving ? 0.6 : 1 }}>
                {saving ? 'Sparar…' : 'Spara'}
            </button>
            <div style={{ fontSize: '12px', color: '#666', maxWidth: '350px' }}>
                Larmregler med <strong>Kräver avvikelserapportering</strong> aktiverat skickar en påminnelse till kontakterna
                om ingen avvikelserapport har skickats in inom angiven tid.
            </div>
        </CollapsiblePanel>
    );
};

export default DeviationSettings;
